const info = {
  ZH: { //中文翻译
    title: "\u67E5\u627EMDS",
    componentName: "\u96F6\u90E8\u4EF6\u540D\u79F0\:",
    componentNum: "\u96F6\u90E8\u4EF6\u53F7\:",
    componentID: "\u96F6\u90E8\u4EF6 ID\:",
    semiComponentName: "\u534A\u6210\u54C1\u4EF6\u540D\u79F0\:",
    semiComponentNum: "\u534A\u6210\u54C1\u4EF6\u53F7\:",
    semiComponentID: "\u534A\u6210\u54C1\u4EF6ID\:",
    matName: "\u6750\u6599\u540D\u79F0\:",
    matNum: "\u6750\u6599\u53F7\:",
    matID: "\u6750\u6599 ID\:",
    cver: "\u7248\u672C\:",
    name: "\u540D\u79F0\:",
    longDescription: "\u96F6\u90E8\u4EF6\u53F7\u3001\u534A\u6210\u54C1\u4EF6\u53F7\u3001\u6750\u6599\u53F7",
    shortDescription: "\u96F6\u90E8\u4EF6\u53F7\u3001\u534A\u6210...",
    alertMustSelect: "\u672C\u4F01\u4E1A\u7684\u6750\u6599\u6570\u636E/\u7EC4\u4EF6\u5355\u5143 \u4E2D\u5FC5\u987B\u9009\u62E9\u4E00\u9879",
    searchMds: "查找材料数据表",
    search: "\u67E5\u627E",
    componentTab: "\u96F6 \u90E8 \u4EF6",
    semiComponentTab: "\u534A\u6210\u54C1\u4EF6",
    materialTab: "\u6750 \u6599",
    substanceTab: "\u57FA\u672C\u7269\u8D28",
    allMaterialTab: "\u6240\u6709\u6750\u6599\u6570\u636E\u8868/\u7EC4\u4EF6\u5355\u5143",
    allMaterialTabS: "\u6240\u6709\u6570\u636E\u8868",
    chinese: "\u4E2D\u6587",
    english: "\u82F1\u6587",
    foreign: "\u5916\u6587",
    curVersion: "\u5F53\u524D\u7248\u672C",
    allVersion: "\u6240\u6709\u7248\u672C",
    materialID: "\u6750\u6599\u4EE3\u53F7/\u6807\u8BC6\:",
    materialNum: "\u6750\u6599\u4EE3\u53F7\:",
    date: "\u65E5\u671F\:",
    onlyforMDS: "(\u4EC5\u9002\u7528\u4E8E\u6750\u6599\u6570\u636E\u8868)",
    published: "\u5DF2\u88AB\u6279\u51C6/\u5DF2\u53D1\u5E03/\u5DF2\u5185\u90E8\u53D1\u5E03",
    created1:'\u5DF2\u521B\u5EFA\u7684\u81EA\u5DF1\u7684\u6750\u6599\u6570\u636E\u8868',
    created: "\u5DF2\u521B\u5EFA\u7684\u81EA\u5DF1\u7684\u6750\u6599\u6570\u636E\u8868/\u7EC4\u4EF6\u5355\u5143",
    dateFrom: "\u4ECE\:",
    dateTo: "\u5230\:",
    to:"\u81f3",
    StartDate:"\u5f00\u59cb\u65e5\u671f",
    StopDate:"\u7ed3\u675f\u65e5\u671f",
    dateFormat: "[\u5E74(4\u4F4D)-\u6708(2\u4F4D)-\u65E5(2\u4F4D)]",
    publish: "\u4F9B\u5E94\u5546\u7684\u6750\u6599\u6570\u636E\u8868",
    approvedMDS: "\u5DF2\u6279\u51C6\u7684\u6750\u6599\u6570\u636E\u8868",
    publishedMDS: "\u5DF2\u53D1\u5E03\u7684\u6750\u6599\u6570\u636E\u8868",
    supplies: "\u4F9B\u5E94\u5546\:",
    nosupplier: "\u8BF7\u9009\u62E9\u8981\u67E5\u627E\u7684\u4F9B\u5E94\u5546",
    select: "(\u8BF7\u9009\u62E9...)",
    existsupplier: "\u4E0D\u80FD\u9009\u62E9\u76F8\u540C\u7684\u4F9B\u5E94\u5546",
    isAll: "\u5168\u90E8",
    ownMDS: "\u672C\u4F01\u4E1A\u7684\u6750\u6599\u6570\u636E\u8868",
    ownUnit: "\u7EC4\u4EF6\u5355\u5143",
    mds: "\u6750\u6599\u6570\u636E\u8868",
    unit: "\u7EC4\u4EF6\u5355\u5143",
    assignedDep: "\u88AB\u6307\u6D3E\u7684\u90E8\u95E8\:",
    assignedMan: "\u88AB\u6307\u6D3E\u7684\u8054\u7CFB\u4EBA\:",
    lastModify: "最近自己修改过的",
    goodName: "\u5546\u54C1\u540D\:",
    isStand: "\u662F\u5426\u6807\u51C6\u6750\u6599",
    importStandard: "\u6750\u6599\u4EE3\u53F7/\u6807\u8BC6\u5F15\u7528\u6807\u51C6\:",
    matClassification: "\u6750\u6599\u5206\u7C7B\:",
    aliaName: "\u540D\u79F0/\u522B\u540D/\u82F1\u6587\u540D\u79F0\:",
    casNumber: "CAS \u7F16\u53F7\:",
    classification: "\u7C7B\:",
    gasdl: "GADSL\u5206\u7C7B\:",
    mustApply: "\u9700\u7533\u62A5",
    yes: "\u662F",
    no: "\u5426",
    notsure: "\u672A\u786E\u5B9A",
    prohibit: "\u88AB\u7981\u6B62",
    cancel: "\u53D6\u6D88",
    noresult: "\u6CA1\u6709\u7B26\u5408\u6761\u4EF6\u7684\u6570\u636E\!",
    addcamds: "CAMDS\u7BA1\u7406\u59D4\u5458\u4F1A",
    addcamds2: "CAMDS\u6750\u6599\u5DE5\u4F5C\u59D4\u5458\u4F1A",
    svhc: "\u9AD8\u5173\u6CE8",
    reachSvhc: "REACH-SVHC\:",
    einecs: "EC\u7F16\u53F7\:",
    FuzzyIdentifier: "\u5355\u51FB\u8F93\u5165\u4E00\u4E2A\u901A\u914D\u7B26\u201C?\u201D",
    export: "\u5BFC\u51FA",
    overdue: "\u8FC7\u671F",
    latestcvel: "\u6700\u65B0\u7248\u672C",
    validity: "\u6570\u636E\u6709\u6548\u6027\uFF1A",
    sample: "\u521d\u7248",
    issamplemds: " \u662F",
    notsamplemds: " \u5426",
    valid: " \u6709\u6548",
    expired: " \u8FC7\u671F",
    listSearch:"\u6e05\u5355\u67e5\u627e",
    file:"\u6e05\u5355\u4e0a\u4f20",
    download:"\u4E0B\u8F7D\u6A21\u677F",
    activateSupplierTip:'选择“已批准的材料数据表”或“已发布的材料数据表”后，才能选择“全部”。'
  },
  EN: { //英文翻译
    title: "MDSs & Modules Search",
    componentName: "Article Name\:",
    componentNum: "Part/Item No.:",
    componentID: "ID:",
    semiComponentName: "Article Name:",
    semiComponentNum: "Item- /Mat.-No.:",
    semiComponentID: "ID:",
    matName: "Material Name\:",
    matNum: "Material No.:",
    matID: "ID:",
    name: "Material Name:",
    longDescription: "Component No., Semicomponent No., Material No.",
    shortDescription: "Component No....",
    alertMustSelect: "own MDSs/Modules must select one",
    searchMds: "MDSs & Modules Search",
    search: "Search",
    componentTab: "Component",
    semiComponentTab: "Semicomponent",
    materialTab: "Material",
    substanceTab: "Basic Substance",
    substanceTabS: "Basic...",
    allMaterialTab: "All MDSs/Modules",
    allMaterialTabS: "All MDSs",
    chinese: "CN",
    english: "EN",
    foreign: "FR",
    curVersion: "Current version",
    allVersion: "All versions",
    materialID: "Material Code/Symbol\:",
    materialNum: "Material code:",
    date: "Date:",
    onlyforMDS: "(only for MDSs)",
    published: "Accepted /Published/ Internally released",
    created1: "Created (own MDSs)",
    created: "Created (own MDSs/Modules)",
    dateFrom: "From:",
    dateTo: "To:",
    to:'To',
    StartDate:'Start date',
    StopDate:'Stop date',
    dateFormat: "[Year(four digits)-Month(two digits)-Day(two digits)]",
    publish: "Supplier MDSs",
    approvedMDS: "Accepted MDSs",
    publishedMDS: "Published MDSs",
    supplies: "Supplier:",
    select: "(please select...)",
    existsupplier: "It is not allowed to select one supplier twice",
    isAll: "All",
    ownMDS: "Own MDSs",
    ownUnit: "Modules",
    mds: "MDSs",
    unit: "Modules",
    assignedDep: "assigned department:",
    assignedMan: "assigned recipients:",
    lastModify: "last edited by me",
    goodName: "Trade name:",
    importStandard: "Norm/Standard:",
    isStand: "is Standard Material",
    matClassification: "Material classification:",
    aliaName: "Name / Synonym / English Name:",
    casNumber: "CAS No.:",
    classification: "Group:",
    gasdl: "GADSL category\:",
    mustApply: "duty-to-declare",
    yes: "yes",
    no: "no",
    notsure: "N.A",
    prohibit: "Prohibited",
    cancel: "cancel",
    noresult: "no suitable data\!",
    addcamds: "CAMDS management committee",
    addcamds2: "CAMDS Material Working Committee",
    reachSvhc: "REACH-SVHC\:",
    svhc: "SVHC",
    einecs: "EC-Index\:",
    nosupplier: "Please select a supplier",
    FuzzyIdentifier: "Click to enter a wildcard character\u201C?\u201D",
    export: "Export",
    cver: "version",
    overdue: "Obsolete",
    latestcvel: "LatestVer",
    validity: "Validity",
    sample: "Sample",
    issamplemds: " Yes",
    notsamplemds: " No",
    valid: " Valid",
    expired: " Obsolete",
    listSearch:'list search',
    file:"List upload",
    download:"Download Template",
    activateSupplierTip:"Please select “Accepted MDSs” or “Published MDSs” before you select “All”."
  }
}
export default info //需要暴露出去
